import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ImportarLineasPedidosExcel from '../../components/importarLineasPedidosExcel/ImportarLineasPedidosExcel'
import {submitImportarLineasPedidosExcel, cerrarModalImportarLineasPedidosExcel, subirArchivosImportarLineasPedidosExcel, abrirModalImportarLineasPedidosExcel, descargarPlantillaExcelLineasPedidosExcel} from '../../actions/importarLineasPedidosExcel/importarLineasPedidosExcel'

export function mapStateToProps (state) {
  return {
    ...state.importarLineasPedidosExcel,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      submitImportarLineasPedidosExcel,
      cerrarModalImportarLineasPedidosExcel,
      subirArchivosImportarLineasPedidosExcel,
      abrirModalImportarLineasPedidosExcel,
      descargarPlantillaExcelLineasPedidosExcel
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ImportarLineasPedidosExcel))